/**
 * TeamSystem Impact - Compliance Path · Engagement drill-down
 */

import { Box, Button, Chip, Grid, Stack, Typography } from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { CompliancePathData } from './useCompliancePath';

const Kpi = ({ value, label }: { value: number | string; label: string }) => (
  <Box>
    <Typography variant="h5" fontWeight={700}>{value}</Typography>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
  </Box>
);

export const EngagementDrill = ({ data }: { data: CompliancePathData['engagement'] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        <Grid item xs={6}><Kpi value={data.campaignsTotal} label={t('dashboard.path.engCampaigns')} /></Grid>
        <Grid item xs={6}><Kpi value={data.responses} label={t('dashboard.path.engResponses')} /></Grid>
      </Grid>

      {data.campaigns.length > 0 ? (
        <Box>
          <Typography variant="subtitle2" gutterBottom>{t('dashboard.path.engCampaignsList')}</Typography>
          <Stack spacing={1}>
            {data.campaigns.map((c) => (
              <Box
                key={c._id}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ p: 1, borderRadius: 1, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}
              >
                <Typography variant="body2" noWrap sx={{ mr: 1 }}>{c.name}</Typography>
                <Chip
                  size="small"
                  label={t('dashboard.path.chipResponses', { n: data.responsesByCampaign[c._id] ?? 0 })}
                />
              </Box>
            ))}
          </Stack>
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">{t('dashboard.path.engEmpty')}</Typography>
      )}

      <Box>
        <Button size="small" endIcon={<OpenInNewIcon />} onClick={() => navigate('/engagement')}>
          {t('dashboard.path.engOpenModule')}
        </Button>
      </Box>
    </Stack>
  );
};
